import { useEffect, useRef, useState } from 'react';

import { Cropper } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';

import Typography from '@material-ui/core/Typography';

import NibDialog from '../NibDialog/NibDialog';

const ImageCropper = ({ imageFile, onCrop, onCancel }) => {
  const [image, setImage] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const cropperRef = useRef(null);

  useEffect(() => {
    if (imageFile.constructor === File && imageFile.lastModified !== 0) {
      setImage(URL.createObjectURL(imageFile));
      setOpen(true);
    }
  }, [imageFile]);

  const urlToFile = (url) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], imageFile.name, { type: imageFile.type, lastModified: 0 });
      });
  };

  const onDialogClose = (isAgree) => {
    if (isAgree) {
      const cropper = cropperRef.current;
      if (cropper) {
        const canvas = cropper.getCanvas();
        if (canvas) {
          urlToFile(canvas.toDataURL()).then((file) => {
            onCrop(file);
            setOpen(false);
          });
        }
      }
    } else {
      onCancel();
      setOpen(false);
    }
  };

  return (
    <NibDialog useButtons={true} open={isOpen} onClose={onDialogClose} width={'40%'}>
      <Cropper
        ref={cropperRef}
        src={image}
        stencilProps={{
          aspectRatio: 16 / 9,
          resizable: true,
        }}
      />
      <div className="w-full flex justify-center mt-[15px]">
        <Typography>
          <strong>Use the mouse wheel to scale the image</strong>
        </Typography>
      </div>
    </NibDialog>
  );
};

export default ImageCropper;
